var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('buttons.download'),"title":_vm.$t('buttons.download'),"id":"download-button"},on:{"click":_vm.download}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('buttons.download')))]),_vm._v(" "),(_vm.selectedCount > 0)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.selectedCount))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ed4c62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Download.vue
// module id = 362
// module chunks = 0